// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6l33h","content":"styles_content__3Zv5z"};